<template>
<section class="mall-image-data">
    <div class="mall-image-container w">
        <div class="mall-image-title">行业解决方案<span>INDUSTRY SOLUTIONS</span></div>
        <div class="mall-image-header">
            <div class="mall-image-header-search">
                <el-input v-model="searchText" placeholder="请输入检索关键词"
                    @keyup.enter.native="searchDataByText"></el-input>
                <el-button type="primary" @click="searchDataByText">搜索</el-button>
            </div>
        </div>

        <div class="mall-image-content">
            <div class="mall-image-content-operate">
                <span>排序：</span>
                <el-link type="primary" :underline="false" @click="sortByPrice">价格
                    <i :class="[this.sortType === 3 ? 'el-icon-top':'el-icon-bottom']"></i></el-link>
                <el-link type="primary" @click="sortType = 2, getGoodsData()"
                    :underline="false">销量<i class="el-icon-bottom"></i></el-link>
                <el-link type="primary" @click="sortType = 4, getGoodsData()"
                    :underline="false">新品<i class="el-icon-bottom"></i></el-link>
                <el-link type="primary" @click="sortType = 1, getGoodsData()"
                    :underline="false">评论量<i class="el-icon-bottom"></i></el-link>
            </div>
            <div class="mall-image-goods">
                <GoodsCard v-for="item in solutionData" :data="item"></GoodsCard>
                <el-empty description="暂无解决方案内容" v-if="!solutionData.length"></el-empty>
            </div>
            <el-pagination :current-page.sync="currentPage" @current-change="getGoodsData"
                :page-size="12" layout="total, prev, pager, next" :total="dataSum"></el-pagination>
        </div>
    </div>
    <CategorySwitch></CategorySwitch>
</section>
</template>

<script>
import GoodsCard from '../../../components/RemoteSensingMall/GoodsCard.vue';
import CategorySwitch from '../../../components/RemoteSensingMall/CategorySwitch.vue'
export default {
    name: 'IndustrySolution',
    components: {
        GoodsCard, CategorySwitch
    },
    data() {
        return {
            searchText: null,
            sortType: 0,
            solutionData: [],
            currentPage: 1,
            dataSum: 0
        }
    },
    mounted() {
        this.getGoodsData()
    },
    computed: {

    },
    methods: {
        getGoodsData() {
            
        },
        searchDataByText() {
            this.currentPage = 1
            this.getGoodsData()
        },
        sortByPrice() {
            if(this.sortType === 3) {
                this.sortType = 5
                this.getGoodsData()
            }else {
                this.sortType = 3
                this.getGoodsData()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.mall-image-data {
    width: 100%;
    background-color: #F5F5F5;

    >.mall-image-container {
        display: flex;
        flex-direction: column;

        >.mall-image-title {
            padding: 30px 0;
            padding-left: 12px;
            color: #2569F2;
            font-size: 24px;
            font-weight: 700;

            >span {
                margin-left: 20px;
                color: #798AAC;
                font-size: 16px;
            }
        }

        >.mall-image-header {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: fit-content;
            margin-bottom: 32px;
            padding: 20px;
            border-radius: 6px;
            background-color: white;

            ::v-deep input {
                background-color: #F5F5F5;
            }

            >.mall-image-header-search {
                display: flex;
                align-items: center;

                >button {
                    margin-left: 10px;
                }

                > a {
                    margin-left: 20px;
                    font-size: 14px;
                    white-space: nowrap;
                    user-select: none;

                    i {
                        margin-left: 6px;
                    }
                }
            }

            >.mall-image-header-advanced {
                display: flex;
                align-items: center;

                >.el-divider {
                    margin: 0 20px;
                }

                >span {
                    font-size: 14px;
                    font-weight: 700;
                    white-space: nowrap;
                }

                >.el-date-editor {
                    margin: 0 20px;
                    background-color: #F5F5F5;

                    > ::v-deep .el-range-separator {
                        margin-left: -12px;
                        width: 6%;
                    }
                }
                > .el-select{
                    margin: 0 20px;
                }
            }
        }

        > .mall-image-content{
            display: flex;
            flex-direction: column;

            > .mall-image-content-operate{
                display: flex;
                align-items: center;
                padding: 0 12px;

                > span {
                    margin-right: 40px;
                    font-size: 14px;
                    font-weight: 700;
                }
                > a {
                    margin: 0 30px;

                    i {
                        margin-left: 6px;
                    }
                }
            }
            > .mall-image-goods{
                display: flex;
                flex-direction: row;
                align-items: center;
                flex-wrap: wrap;

                > div {
                    flex: 0 0 25%;

                    @media (max-width: 1024px) { flex: 0 0 33%;}
                }
                > .el-empty {
					margin: 0 auto;
				}
            }
            > ::v-deep .el-pagination{
                margin: 60px 0;

                > button {
                    width: 35px;
                    height: 35px;
                    padding: 0;
                    background-color: transparent;
                    border-radius: 6px;
                }
                > ul {
                    margin: 0 6px;

                    > li {
                        width: 35px;
                        height: 35px;
                        margin: 0 6px;
                        background-color: transparent;
                        border-radius: 6px;
                        line-height: 35px;
                        transition: .2s;

                        &:hover {
							color: #2569F2;
						}
						&.active {
							color: white;
							background-color: #2569F2;

							&:hover {
								color: white;
							}
						}
                    }
                }
            }
        }
    }
}
// 动画
.stretch-enter-active, .stretch-leave-active{
    transition: .2s;
}
.stretch-enter, .stretch-leave-to {
    opacity: 0;
}
</style>